import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { StatusScreen } from '../../../../../../components/status-screen';
import { ROUTES } from '../../../../../../routes/routes';
import { StatusTypeEnum } from '../../../../../../types';
import * as exalusStorage from '../../../../storage';

const CreateAccountOffer: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('dashboard');

  const handleCreateAccount = () => {
    localStorage.removeItem('local-app');
    window.location.href = ROUTES.Root();
  };

  const handleMaybeLater = () => {
    exalusStorage.setItem('remindCreateAccount', new Date());
    navigate(-1);
  };

  return (
    <StatusScreen
      header={t('createAccountOffer.header')}
      subTitle={t('createAccountOffer.content')}
      type={StatusTypeEnum.MIGRATION}
      primaryBtnText={t('createAccountOffer.createAccount')}
      onPrimaryBtnClick={handleCreateAccount}
      secondaryBtnText={t('createAccountOffer.maybeLater')}
      onSecondaryBtnClick={handleMaybeLater}
      secondaryBackground
      noBackButton
    />
  );
};

export default CreateAccountOffer;
